module.exports = __webpack_public_path__ + "img/app-table-number.39d2c9ac.png";